// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"6ed253c1","56":"c2e16794","79":"9807ebb2","231":"1a981e1b","259":"8e487695","288":"efa3d4f3","426":"82789f12","915":"341eaa5e"}[chunkId] + ".chunk.css";
};